/* ZIRAK WISHLIST - Zirak's own wishlist (no app).
   - Saves product handles in the shopper's browser (localStorage), newest first, max 100.
   - Any element with data-zw-handle="product-handle" is a heart toggle (cards + product page).
   - Header heart links to /pages/wishlist and shows the count (.zw-count).
   - Fires "zirak:wishlist:change" on document after every add/remove.
   - New hearts (cards loaded later) are updated on the next frame - throttled, not debounced,
     so apps that change the page every second can't delay it.
   - window.ZirakWishlist = { read, has, toggle, remove, sync } */
(function () {
  if (window.ZirakWishlist) return;
  var KEY = 'zirak_wishlist_v1';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100))); } catch (e) {}
  }
  function has(h) { return read().indexOf(h) > -1; }
  function emit(h, on) {
    document.dispatchEvent(new CustomEvent('zirak:wishlist:change', { detail: { handle: h, on: on, list: read() } }));
  }
  function toggle(h) {
    var list = read();
    var i = list.indexOf(h);
    var on = i === -1;
    if (on) list.unshift(h); else list.splice(i, 1);
    write(list);
    sync();
    emit(h, on);
    return on;
  }
  function remove(h) {
    var list = read();
    var i = list.indexOf(h);
    if (i === -1) return;
    list.splice(i, 1);
    write(list);
    sync();
    emit(h, false);
  }

  function header() {
    document.querySelectorAll('.zh-wrap a.wishlist-hero-header-icon, .zh-wrap a[data-zh-wishlist-page]').forEach(function (a) {
      if (a.dataset.zwReady) return;
      a.dataset.zwReady = '1';
      a.classList.remove('wishlist-hero-header-icon');
      a.classList.add('zh-wl');
      a.setAttribute('href', ROOT + 'pages/wishlist');
      a.setAttribute('aria-label', 'Wishlist');
      if (!a.querySelector('.zw-count')) {
        var s = document.createElement('span');
        s.className = 'zw-count';
        s.hidden = true;
        s.setAttribute('aria-hidden', 'true');
        a.appendChild(s);
      }
    });
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-zw-handle]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-zw-handle')) > -1;
      if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on);
      var pressed = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== pressed) {
        b.setAttribute('aria-pressed', pressed);
        b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      }
    });
    document.querySelectorAll('.zw-count').forEach(function (c) {
      var txt = list.length > 99 ? '99+' : String(list.length);
      if (c.textContent !== txt) c.textContent = txt;
      c.hidden = list.length === 0;
    });
  }

  // Heart taps (capture phase so a heart inside a card link never opens the product)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zw-handle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.getAttribute('data-zw-handle'));
    b.classList.remove('zw-pop');
    void b.offsetWidth;
    if (on) b.classList.add('zw-pop');
  }, true);

  // Other tabs
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  function refresh() { header(); sync(); }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; refresh(); });
  }
  function relevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && (node.matches('[data-zw-handle], .zh-wrap, a[data-zh-wishlist-page]'))) return true;
    return !!(node.querySelector && node.querySelector('[data-zw-handle], a[data-zh-wishlist-page]'));
  }
  function start() {
    refresh();
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (relevant(added[j])) { queue(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.ZirakWishlist = { read: read, has: has, toggle: toggle, remove: remove, sync: sync };
})();
